import { SpkGovernanceContainer } from '@/features/spk-governance/SpkGovernanceContainer'

export function SpkGovernance() {
  return <SpkGovernanceContainer />
}
